import React from 'react';
// import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types';
// import Router from 'next/router'
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { withStyles } from '@material-ui/styles';
import { Typography, Button } from '@material-ui/core';

import moment from 'moment';

// import './calendarPicker.scss';

const NavbarMobile = ({
  classes,
  onPreviousClick,
  onNextClick,
  month,
  showPreviousButton,
  showNextButton,
}) => (
  <div className={classes.header}>
    <Button onClick={() => onPreviousClick()} disabled={!showPreviousButton} color="secondary">
      <ChevronLeftIcon />
    </Button>
    <Typography variant="button" color="secondary">
      {`${moment(month).format('MMMM')} de ${moment(month).format('YYYY')}`}
    </Typography>
    <Button onClick={() => onNextClick()} disabled={!showNextButton} color="secondary">
      <ChevronRightIcon />
    </Button>
  </div>
);

NavbarMobile.propTypes = {
  classes: PropTypes.object.isRequired,
  month: PropTypes.object.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onPreviousClick: PropTypes.func.isRequired,
  showNextButton: PropTypes.bool,
  showPreviousButton: PropTypes.bool,
};

NavbarMobile.defaultProps = {
  showNextButton: true,
  showPreviousButton: true,
};

const styles = () => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

export default withStyles(styles)(NavbarMobile);
